import { Card } from "./ui/card";
import { Calendar, Map, Users } from "lucide-react";

const steps = [
  {
    icon: Calendar,
    title: "Outline Your Dates",
    desc: "Choose when and how long your adventure will be.",
  },
  {
    icon: Map,
    title: "Build Your Itinerary",
    desc: "Add destinations, sights, and activities—see them come alive on a map!",
  },
  {
    icon: Users,
    title: "Share & Collaborate",
    desc: "Invite friends, save, and share your plans in a snap.",
  },
];

const HowItWorks = () => (
  <section className="w-full max-w-4xl mx-auto px-4 py-14">
    <h2 className="text-2xl md:text-3xl font-extrabold text-center text-slate-900 dark:text-white mb-10">
      How It Works
    </h2>
    <div className="grid md:grid-cols-3 gap-8">
      {steps.map(({ icon: Icon, title, desc }, i) => (
        <Card
          key={title}
          className="flex flex-col items-center p-8 rounded-2xl shadow-xl bg-white/70 dark:bg-slate-900/60 backdrop-blur-sm border-none hover:-translate-y-1.5 hover:shadow-2xl transition-all"
          style={{ transitionDelay: `${i * 80}ms` }}
        >
          <span className="mb-4 flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-sky-400 to-teal-400 text-white shadow-lg">
            <Icon className="w-7 h-7" />
          </span>
          <h3 className="font-semibold text-xl text-slate-900 dark:text-white mb-2 text-center">
            {title}
          </h3>
          <p className="text-slate-600 dark:text-slate-300 text-center text-base">
            {desc}
          </p>
        </Card>
      ))}
    </div>
  </section>
);

export default HowItWorks;
